"use client";

import { useEffect, useState } from "react";
import { useParams } from "next/navigation";

import { pathToHref } from "utils/link";
import { Locale } from "consts/locale";

export const useGetCurrentUrl = (): string => {
  const params = useParams();
  const locale = params?.locale as Locale;
  const [link, setLink] = useState<string>("");

  useEffect(() => {
    setLink(pathToHref(locale, window.location.pathname));
  }, [locale]);

  return link;
};
